import { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Modal } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import camara from "../assets/img/11111.png";
import cohete from "../assets/img/2.png";
import podcast from "../assets/img/podcats.png";
import bot from "../assets/img/chatbot.png";
import infoMarketingDigital from "../assets/img/info_marketing_digital.png";
import streamingypodcast from "../assets/img/streaming y podcats.png";
import streamingPC from "../assets/img/Streaming2.png";
import eventosPC from "../assets/img/Eventos3.png";
import ChatbotsPC from "../assets/img/chatbot1.png";
import servicioEventos from "../assets/img/eventos.png";
import marketingpc from "../assets/img/markdigitalpc.png";
import servicioChatBot from "../assets/img/servicio chat bot.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import AOS from "aos";
import "aos/dist/aos.css";
import ModalPC from "./ModalPC";

export const Projects = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeProject, setActiveProject] = useState(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const projects = [
    {
      title: "Marketing Digital",
      imgUrl: cohete,
      image: {
        pc: marketingpc, // Imagen horizontal para PC
        mobile: infoMarketingDigital, // Imagen vertical para móvil
      },
    },
    {
      title: "Streaming & Podcast",
      imgUrl: podcast,
      image: {
        pc: streamingPC, // Imagen horizontal para PC
        mobile: streamingypodcast, // Imagen vertical para móvil
      },
    },
    {
      title: "Cobertura y Desarrollo de Eventos",
      imgUrl: camara,
      image: {
        pc: eventosPC, // Imagen horizontal para PC
        mobile: servicioEventos, // Imagen vertical para móvil
      },
    },
    {
      title: "Chatbots",
      imgUrl: bot,
      image: {
        pc: ChatbotsPC, // Imagen horizontal para PC
        mobile: servicioChatBot, // Imagen vertical para móvil
      },
    },
  ];

  const handleCardClick = (project) => {
    setActiveProject(project);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setActiveProject(null);
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12} className="text-center">
            <TrackVisibility>
              {({ isVisible }) => {
                if (isVisible && !hasAnimated) {
                  setHasAnimated(true);
                }
                return (
                  <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                    <Tab.Container id="projects-tabs" defaultActiveKey="first">
                      <Nav variant="pills" className="nav-pills mb-4 justify-content-center">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Servicios</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Contacto</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">¿Quiénes somos?</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content>
                        <Tab.Pane eventKey="first" className="tab-pane-margin">
                          <Row className="justify-content-center">
                            {projects.map((project, index) => (
                              <Col
                                xs={12}  // 1 por fila en mobile
                                sm={6}   // 2 por fila en tablets
                                lg={6}   // 2 por fila en pantallas medianas
                                xl={3}   // 4 por fila en 1440px o más
                                key={index}
                                data-aos="zoom-in"
                                data-aos-delay={index * 200}
                                onClick={() => handleCardClick(project)}
                                className="d-flex justify-content-center"
                              >
                                <ProjectCard {...project} />
                              </Col>
                            ))}
                          </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second" className="text-center tab-pane-margin">
                          <a
                            href="https://api.whatsapp.com/send?phone=5492612061502"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-button"
                          >
                            Enviar Mensaje a WhatsApp
                          </a>
                          <h4>Email: pintamkt@gmail.com</h4>
                        </Tab.Pane>
                        <Tab.Pane eventKey="third" className="text-center tab-pane-margin">
                          <h4>
                            Somos una agencia 360 que trabaja para convertir ideas en proyectos exitosos. Nos especializamos en brindar soluciones integrales de marketing digital y producción audiovisual.
                          </h4>
                          <h3>¡Sumate al cambio digital con nosotros!</h3>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                );
              }}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      {activeProject && (
        window.innerWidth > 1023 ? (
          <ModalPC show={showModal} onClose={handleClose} project={activeProject} />
        ) : (
          <Modal
            show={showModal}
            onHide={handleClose}
            centered
            size=""
          >
            <Modal.Header closeButton />
            <Modal.Body className="text-center">
              <img
                src={activeProject.image.mobile}
                alt={activeProject.title}
                style={{
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: "10px",
                }}
              />
            </Modal.Body>
          </Modal>
        )
      )}


    </section>
  );
};
